import { RepositoryFactory } from '@/api/RepositoryFactory';
import { ActionTree, Module } from 'vuex';
import { UserState } from '@/store/storeStateInterface';
import User from '@/models/User';
import UserRepository from '@/api/UserRepository';

const userRepository: UserRepository = RepositoryFactory.get('user');

const store: UserState = {
    allUsers: []
};

const actions: ActionTree<any, any> = {
    getAllUsersAction: async ({ commit }): Promise<User[]> => {
        const userData = await userRepository.getAllUsers();
        const users = User.parseFromArray(userData) as User[];
        commit('saveAllUsers', { users });
        return users;
    },
    listUsersAction: async ({ commit }): Promise<User[]> => {
        const userData = await userRepository.listUsers();
        const users = User.parseFromArray(userData) as User[];
        commit('saveAllUsers', { users });
        return users;
    },
    createUserAction: async ({ dispatch }, payload: { username: string; password: string; firstName?: string; lastName?: string; email?: string; phone?: string; role?: string }): Promise<User> => {
        await userRepository.createUser(payload);
        await dispatch('listUsersAction');
        return {} as User;
    },
    updateUserAction: async ({ dispatch }, payload: { userId: string; firstName?: string; lastName?: string; email?: string; phone?: string; role?: string }): Promise<User> => {
        await userRepository.updateUser(payload.userId, payload);
        await dispatch('listUsersAction');
        return {} as User;
    },
    deleteUserAction: async ({ dispatch }, payload: { userId: string }): Promise<void> => {
        await userRepository.deleteUser(payload.userId);
        await dispatch('listUsersAction');
    },
    changePasswordAction: async ({ dispatch }, payload: { userId: string; password: string }): Promise<void> => {
        await userRepository.changePassword(payload.userId, payload.password);
        await dispatch('listUsersAction');
    },
    changeRoleAction: async ({ dispatch }, payload: { userId: string; role: string }): Promise<void> => {
        await userRepository.changeRole(payload.userId, payload.role);
        await dispatch('listUsersAction');
    }
};

const mutations = {
    saveAllUsers: (state: UserState, payload: { users: User[] }) => {
        state.allUsers = payload.users;
    }
};

const getters = {
    allUsers: (state: UserState) => {
        return state.allUsers;
    }
};

const userStore: Module<any, any> = {
    state: store,
    actions,
    mutations,
    getters
};

export default userStore;
